<template>
  <div>
    <Hero :title="$t('message.hero.confirmIdTitle')"></Hero>
    <p v-if="isAVRMobile && disclaimerText">
      {{ disclaimerText }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { CreditDataSourceCA } from '@/utils/enums';
import Hero from '../../Hero.vue';

export default {
  name: 'ConfirmID',
  components: {
    Hero,
  },
  computed: {
    ...mapGetters('business', ['getDefaultCreditDataSourceCA']),
    disclaimerText() {
      return this.getDefaultCreditDataSourceCA === CreditDataSourceCA.EQUIFAX
        ? this.$t('message.credit.confirmIdEquifaxCardText')
        : this.getDefaultCreditDataSourceCA === CreditDataSourceCA.CREDIT_PLUS
        ? this.$t('message.credit.confirmIdCardText')
        : null;
    },
  },
};
</script>

<style scoped></style>
